(function($, undefined) {
	
	'use strict';
	var notificationUtils;
	var formValidator;
	var utils;
	var form;
	var popup;
	var lang;
	var titles;
	var personId;
	var personName;
	var personFName;
	var personLName;
	var auditionState;
	var auditionId;
	var auditionName;
	var auditionClientJson;
	var auditionFileType;
	var isVideo;
	var searcherId;
	var agencyId;
	var inviteId;
	var researcherId;
	var agencyName;
	var isAutonomous;
	var agenciesListForAutonomous;
	var applicationId;
	var acceptAuditionBtn;
	var denyInvitationAgencyBtn;
	var addDemoInput;
	var addDemoBtn;
	var submitDemoByAgency;
	var reviewDemoByAgency;
	var submitDemoToResearcher;
	var submitApplicationBtn;
	var demoLimit;
	var scriptDemoRecommendedCheck;
	var orderBtns;
	var moreApplicationsBtns;
	var orderReverse;
	var mainContent;
	var orderListCtn;
	var commentaireBtn;
	var commentaireDelBtn;
	var isOwnerResearcher;
	var sendToForm;
	var sendSelectEmail;
	var sendToSelect;
	var auditionDemoStateSelect;
	var toggleArtistRecommendedMsgCheckbox;
	var toggleArtistNotRecommendedMsgCheckbox;
	var demoState;
	var recommendedDate;
    var applicationNotification;

	var dateChanged = false;
	var emailLimit = 0;
	var emailCount = 0;
	var changedNowSelected = [];
	var changedNowNotSelected = [];
	var currAuditionState = null;
	
	var toggleContent = function () {
		var t = $(this);
		var ctn = t.closest('.audition-specs-item');
		
		if (ctn.hasClass('open')) {
			ctn.removeClass('open');
			$('.audition-specs-content', ctn).slideUp(200);
		} else {
			ctn.addClass('open');
			$('.audition-specs-content', ctn).slideDown(200);
		}
	};
	
	var acceptAudition = function () {
		var t = $(this);
		var hasAgency = agencyId !== '';
		var currAgencyId = $('.audition-single-agency-select').length !== 0 ? $('.audition-single-agency-select').attr('data-value') : agencyId;
		var field7 = '';
		var participationDetails = t.closest('.popup').find('.audition-availability-questions-content-ctn');

		if (t.attr('data-extra') !== undefined) {
			field7 = t.attr('data-extra');
		}
		if (participationDetails.length > 0) {
			formValidator.validateForm(participationDetails);

			if (participationDetails.hasClass('has-error')) {
				return false;
			} else {
				field7 = JSON.stringify({
					"no-concurrence": participationDetails.find('.concurrent-participation-check').prop('checked'),
					"concurrence-details": participationDetails.find('input[name="concurrent-participation-details"]').val(),
					"availability": participationDetails.find('.audition-availability-check').prop('checked'),
					"availability-details": participationDetails.find('input[name="audition-availability-details"]').val(),
					"artist-recording": participationDetails.find('.artist-recording-check').prop('checked'),
					"artist-recording-details": participationDetails.find('input[name="artist-recording-details"]').val()
				});
			}
		}
		
		t.closest('.popup').addClass('is-processing');
		var data = {
			id: applicationId,
			field1: 'application',
			field2: auditionId,
			field3: '1',
			field4: currAgencyId,
			field5: personFName,
			field6: personLName,
			field7: field7,
			field9: personId,
			field19: auditionFileType,
			ajax: true
		};
		
		// console.log(data)
		var newDate = new Date();
		if (applicationId === '') {
			data.dateField1Year = newDate.getFullYear();
			data.dateField1Month = newDate.getMonth();
			data.dateField1Day = newDate.getDate();
			data.dateField1Hour = newDate.getHours();
			data.dateField1Minute = newDate.getMinutes();
			data.dateField1Second = newDate.getSeconds();
		}
		
		function acceptAuditionChangeState () {
			var dataMessage1 = new FormData();
			dataMessage1.append('link', 'true');
			dataMessage1.append('personId', personId);
			dataMessage1.append('targetPersonId', searcherId);
			dataMessage1.append('genDataId', auditionId);
			dataMessage1.append('ajax', 'true');
			
			var dataMessage2 = new FormData();
			dataMessage2.append('link', 'true');
			dataMessage2.append('personId', currAgencyId);
			dataMessage2.append('targetPersonId', searcherId);
			dataMessage2.append('genDataId', auditionId);
			dataMessage2.append('ajax', 'true');
			
			$.ajax({
				url: '/action/writeMessage',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				data: dataMessage1,
				success: function (response) {
					// console.log('Message link artist : ' + response);
					$.ajax({
						url: '/action/writeMessage',
						cache: false,
						contentType: false,
						processData: false,
						method: 'POST',
						data: dataMessage2,
						success: function (response) {
							// console.log('Message link agency : ' + response);
							$.ajax({
								url: '/action/manageGenData',
								cache: false,
								method: 'POST',
								data: data,
								success: function (response) {
									var newId = response.substring('success-'.length);
									// console.log('script: ' + newId);
									
									if (inviteId !== undefined) {
										$.ajax({
											url: '/action/manageGenData',
											cache: false,
											data: {
												id: inviteId,
												field5: '1',
												ajax: true
											},
											success: function (response) {
												// console.log('Accept invite : ' + response);
												if (hasAgency && !isAutonomous) {
													// notificationUtils.sendNotificationPerson(currAgencyId,
													//	 'AUDITION_ARTIST_ACCEPTED',
													//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
													//	 function () {
															window.location.href = window.location.href.split('?')[0];
													//	 },
													//	 {field8: personId}
													// );
												} else {
													// notificationUtils.sendNotificationPerson(researcherId,
													//	 'AUDITION_ARTIST_ACCEPTED_TO_RESEARCHER',
													//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
													//	 function () {
															window.location.href = window.location.href.split('?')[0];
													//	 },
													//	 {field8: personId}
													// );
												}
											}
										});
									} else {
										if (hasAgency && !isAutonomous) {
											// notificationUtils.sendNotificationPerson(currAgencyId,
											//	 'AUDITION_ARTIST_ACCEPTED',
											//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
											//	 function () {
													window.location.href = window.location.href.split('?')[0];
											//	 },
											//	 {field8: personId}
											// );
										} else {
											// notificationUtils.sendNotificationPerson(researcherId,
											//	 'AUDITION_ARTIST_ACCEPTED_TO_RESEARCHER',
											//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
											//	 function () {
													window.location.href = window.location.href.split('?')[0];
											//	 },
											//	 {field8: personId}
											// );
										}
									}
								} 
							});
						}
					});
				}
			});
		}
		
		if (hasAgency) {
			$.ajax({
				url: '/action/vcSendAuditionInvitations',
				cache: false,
				method: 'POST',
				data: {
					agentId: currAgencyId,
					auditionId: auditionId,
					ajax: true
				},
				success: function (response) {
					// console.log('Audition link to agency : ' +  response);
					
					acceptAuditionChangeState();
				}
			});
		} else {
			acceptAuditionChangeState();
		}
	};
	
	var denyInvitationAgency = function () {
		var t = $(this);
		var popup = t. closest('.popup');
		var redirect = t.attr('data-redirect');
		var sendMessage = popup.find('input[name="toggle-agency-refuse-invitation-msg-checkbox"]').prop('checked');
		var message = popup.find('textarea[name="audtion-single-form-message-agency-refuse-text"]').val();

		popup.addClass('is-processing');
		// console.log(inviteId);
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: inviteId,
				field4: '0',
				ajax: true
			},
			success: function (response) {
				// console.log('Deny invite agency : ' + response);
				
				notificationUtils.sendNotificationPerson(researcherId,
					'AUDITION_AGENCY_REFUSED_TO_RESEARCHER',
					agencyName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
					function () {
						if (sendMessage && message.length > 0) {
							var data = new FormData(); 
							data.append('refuseAuditionId', auditionId);
							data.append('targetPersonId', searcherId);
							data.append('message', message);
							data.append('ajax', true);
							//for (var pair of data.entries()) {
							//	console.log(pair[0]+ ', ' + pair[1]); 
							//}

							$.ajax({
								url: '/action/vcWriteMessage',
								cache: false,
								contentType: false,
								processData: false,
								method: 'POST',
								data: data,
								success: function (response) {
                                    console.log(response);
									notificationUtils.sendNotificationPerson(researcherId, 'NEW_MESSAGE', agencyName, function () {
										window.location.href = redirect + '?auditionDeny';
									}, {field8: personId});
								}
							});
						} else {
							window.location.href = redirect + '?auditionDeny';
						}
					},
					{field8: personId}
				);
			}
		});
	};
	
	var checkDemoCount = function () {
		var t = $(this);
		var file = this.files[0];
		var filename = file !== undefined ? file.name : '';
		var currForm = $('.audition-single-add-form');
		var tab = t.closest('.tab-ctn');
		var currDemoCount = $('.audition-single-demo-item:not(.clone)', tab).length + 1;
		
		if (filename !== '' && currDemoCount >= demoLimit) {
			$('.form-item-field[name="audition-single-add-file"]', tab).addClass('disabled').attr('disabled', 'true');
			$('.form-item-field[name="audition-single-add-file"]', tab).closest('.form-item-upload').addClass('disabled');
			$('.audition-single-add-form-note', tab).addClass('highlight');
		}
	};
	
	var addDemoSubmitFromInput = function () {
		var input = $(this);
		var tab = input.closest('.tab-ctn');
		
		addDemoSubmitInput(tab);
	};
	
	var addDemoSubmit = function () {
		var currForm = $('.audition-single-add-form');
		var title = $('.action-form-item', currForm);
		var scriptId = title.attr('data-script-id');
		var tab = $('.tab-ctn[data-tab="'+scriptId+'"]');
		
		popup.closeAllPopup();
		
		addDemoSubmitInput(tab);
	};
	
	var addDemoSubmitInput = function (tab) {
		var scriptId = tab.attr('data-tab');
		var input = $('.form-item-field[name="audition-single-add-file"]', tab);
		var files = input[0].files;
		var clone = $('.audition-single-demo-item.clone', tab);
		var inputForm = $('.audition-single-add-from', tab);
		var list = $('.audition-single-demo-list', tab);
		var addBtn = $('.audition-single-add-button', tab);
		var hasAgency = agencyId !== '';
		var allowedExt = isVideo ? ['mp4','webm', 'mov'] : ['mp3','m4a','wav'];
		var allowedSize = isVideo ? 104857600 : 10485760; // 100mb video / 10mb audio
		var currAgencyId = $('.audition-single-agency-select').length !== 0 ? $('.audition-single-agency-select').attr('data-value') : agencyId;
		
		addBtn.addClass('disabled').attr('disabled', 'true');

		if (files !== undefined) {
			if (files.length) {
				for (var i = 0;i<files.length;i++) {
					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1];
					var size = files[i].size;
					var filename = files[i].name;
					
					var data = new FormData();
					data.append('image', files[i]);
					data.append('customLabel', 'file');
					data.append('directory', 'Audition');
					data.append('ajax', 'true');

					if (size <= allowedSize) {
						if (allowedExt.indexOf(ext.toLowerCase()) !== -1) {
							inputForm.addClass('is-processing');
							
							$.ajax({
								url: '/action/uploadCroppedImage',
								cache: false,
								contentType: false,
								processData: false,
								method: 'POST',
								data: data,
								success: function (response) {
									var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
									// console.log('file: ' + newFileId);
									var newDate = new Date();
									
									var dataSecondStep = {
										field1: 'application-demo',
										field2: scriptId,
										field3: applicationId,
										field4: newFileId,
										field5: filename,
										field6: ext,
										field7: auditionId,
										field8: '0',
										field9: personId,
										field11: searcherId,
										field19: auditionFileType,
										dateField1Year: newDate.getFullYear(),
										dateField1Month: newDate.getMonth(),
										dateField1Day: newDate.getDate(),
										dateField1Hour: newDate.getHours(),
										dateField1Minute: newDate.getMinutes(),
										dateField1Second: newDate.getSeconds(),
										ajax: true
									};
									
									if (hasAgency) {
										dataSecondStep.field10 = currAgencyId;
									}
									
									// console.log('application-demo : ');
									// console.log(dataSecondStep);
									
									$.ajax({
										url: '/action/manageGenData',
										cache: false,
										data: dataSecondStep,
										success: function (genResponse) {
											var newScriptId = genResponse.substring('success-'.length);
											// console.log('application-demo: ' + newScriptId);
											
											inputForm.removeClass('is-processing');
											form.resetUpload(input);
											
											var newElt = clone.clone().removeClass('clone').attr('data-id', newScriptId).attr('data-file-id', newFileId);
											$('.audition-single-demo-item-title', newElt).html(filename);
											var num = Math.random();
											newElt.find('.toggle-tooltip-btn').attr('data-id', num);
											newElt.find('.tooltip-big-ctn').attr('data-id', num);
											
											list.prepend(newElt);
											
											updateScriptCount();
											submitApplicationBtn.removeClass('disabled').removeAttr('disabled');
											$('.audition-single-demo-validate-warning').css('display', 'inline-block');
											
											var currDemoCount = $('.audition-single-demo-item:not(.clone)', tab).length;
											if (currDemoCount === demoLimit) {
												$('.audition-single-add-form-note', tab).addClass('highlight');
											}
											
											if (isVideo) {
												var video = document.createElement('VIDEO');
												video.src = '/static/uploaded/Audition/' + newFileId + '-file.' + ext;
												video.controls = 'controls';
												$('.audition-single-demo-item-audio', newElt).append(video);
											} else {
												var audio = document.createElement('AUDIO');
												audio.src = '/static/uploaded/Audition/' + newFileId + '-file.' + ext;
												audio.controls = 'controls';
												$('.audition-single-demo-item-audio', newElt).append(audio);
											}
										} 
									});
								}
							});
						} else {
							if (isVideo) {
								form.showErrorPopupAnimation('audition-form-artist-file-ext-video-error');
							} else {
								form.showErrorPopupAnimation('audition-form-artist-file-ext-error');
							}
						}
					} else {
						if (isVideo) {
							form.showErrorPopupAnimation('demo-form-file-video-size-message-error');
						} else {
							form.showErrorPopupAnimation('demo-form-file-size-message-error');
						}
					}
				}
			}
		}
	};
	
	var delDemo = function () {
		var t = $(this);
		var item = t.closest('.audition-single-demo-item');
		var id = item.attr('data-id');
		var script = t.closest('.tab-ctn');
		var currDemoCount = $('.audition-single-demo-item:not(.clone)', script).length - 1;
		
		if (currDemoCount === 0) {
			submitApplicationBtn.addClass('disabled').attr('disabled', 'true');
			$('.audition-single-demo-validate-warning').slideUp(200);
		}
		
		if (currDemoCount < demoLimit) {
			$('.form-item-field[name="audition-single-add-file"]', script).removeClass('disabled').removeAttr('disabled');
			$('.form-item-field[name="audition-single-add-file"]', script).closest('.form-item-upload').removeClass('disabled');
			$('.audition-single-add-form-note', script).removeClass('highlight');
		}
		
		item.slideUp(200, function() {
			item.remove();
			updateScriptCount();
		});
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: id,
				delete: true,
				ajax: true
			},
			success: function (response) {
				// console.log('remove application-demo: ' + response);
			} 
		});
	};
	
	var updateScriptCount = function () {
		var elt = $('.audition-scripts-script-count');
		var count = 0;
		
		$('.tab-ctn[data-tab-family="audition-scripts-tabs"]').each(function () {
			if ($('.audition-single-demo-item:not(.clone)', $(this)).length) {
				count++;
			}
		});
		
		elt.html(count);
	};
	
	// @TODO: CHECK ALL CODE IN THIS FUNCTION.
	var changeScriptDemoState = function () {
		var t = $(this);
		var demo = t.closest('.audition-single-artist-item-script-demo-item');
		var main = t.closest('.audition-single-artist-item');
		var classToAdd = 'is-recommended';
		
		if (t.is(':checked')) {
			demo.addClass(classToAdd);
		} else {
			demo.removeClass(classToAdd);
		}
		
		//For agency
		var totalMainCount = $('.audition-single-artist-item-script-demo-recommend:checked', main).length;
		
		if (totalMainCount !== 0) {
			$('.audition-single-select-agency-btn', main).removeClass('disabled').removeAttr('disabled');
		} else {
			$('.audition-single-select-agency-btn', main).addClass('disabled').attr('disabled', true);
		}
		
		//For researcher
		var newCount = $('.audition-single-artist-item-script-demo-item.is-recommended').length;
		var stateChageCount = $('.audition-single-artist-item-script-demo-item[data-init-checked="false"].is-recommended, .audition-single-artist-item-script-demo-item[data-init-checked="true"]:not(.is-recommended)').length;
		$('.audition-single-researcher-tools-recommended-count').html(newCount);
		
		if (stateChageCount) {
			$('.audition-single-select-by-researcher-btn, .audition-single-update-agency-btn').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.audition-single-select-by-researcher-btn, .audition-single-update-agency-btn').addClass('disabled').attr('disabled', 'true');
		}
		
		changedNowSelected = [];
		changedNowNotSelected = [];
		
		var stateToCheck = 'data-default-state';
		
		if (auditionState === '3') {
			stateToCheck = 'data-is-selected';
		} else if ($('.audition-single-audition-is-agency').val() === 'true') {
			stateToCheck = 'data-agency-recommend';
		}
		
		$('.audition-single-artist-item-script-demo-item['+stateToCheck+']').each(function () {
			var c = $(this);
			var cId = c.attr('data-id');
			var defaultState = c.attr(stateToCheck);
			var isChecked = $('.audition-single-artist-item-script-demo-recommend', c).is(':checked');
			
			if ((defaultState === 'not-checked' || defaultState === 'not-selected' || defaultState === 'agency-not-recommend') && isChecked) {
				changedNowSelected.push(cId);
			} else if ((defaultState === 'checked' || defaultState === 'selected' || defaultState === 'agency-recommend') && !isChecked) {
				changedNowNotSelected.push(cId);
			}
		});
		
		if (changedNowSelected.length || changedNowNotSelected.length) {
			$('.audition-single-update-recommended-btn, .audition-single-update-client-btn').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.audition-single-update-recommended-btn, .audition-single-update-client-btn').addClass('disabled').attr('disabled', 'true');
		}
	};
	
	var notifSent = false;
	var submitDemoByAgencySubmit = function () {
		var t = $(this);
		var artistId = t.attr('data-item-id');
		var currArtistCtn = $('.audition-single-artist-item[data-id="'+artistId+'"]');
		var currArtistHeader = $('.audition-single-artist-item-header', currArtistCtn);
		var currPopup = $(this).closest('.popup');
		var total = $('.audition-single-artist-item-script-demo-recommend', currArtistCtn).length;
		var count = 0;
		var newDate = new Date();
		
		currPopup.addClass('is-processing');
		
		$('.audition-single-artist-item-script-demo-recommend', currArtistCtn).each(function () {
			var t = $(this);
			var item = t.closest('.audition-single-artist-item-script-demo-item');
			var id = item.attr('data-id');
			
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: id,
					field8: t.is(':checked') ? '4' : '3',
					dateField2Year: newDate.getFullYear(),
					dateField2Month: newDate.getMonth(),
					dateField2Day: newDate.getDate(),
					dateField2Hour: newDate.getHours(),
					dateField2Minute: newDate.getMinutes(),
					dateField2Second: newDate.getSeconds(),
					ajax: true
				},
				success: function (response) {
					count++;
					// console.log('count: ' + count)
					// console.log('total: ' + total)
					if (count === total) {
						sendHeaderInfo(function () {
							var url = window.location.href;
							url.indexOf('?') !== -1 ? url += '&' : url += '?';
							window.location.href = url + 'successToReseacher';
						}, currArtistCtn);
					} else {
						sendHeaderInfo(function () {
							// Void
						}, currArtistCtn);
					}
				} 
			});
		});
		
		function sendHeaderInfo(callback, currArtistCtn) {
            var currHeader = $('.audition-single-artist-item-header', currArtistCtn);
            var artistId = currHeader.attr('data-artist-id');
            var artistName = currHeader.find(".audition-single-artist-item-name").text();
            $.ajax({
                url: '/action/manageGenData',
                cache: false,
                data: {
                    id: currHeader.attr('data-application-id'),
                    field3: '1',
                    dateField2Year: newDate.getFullYear(),
                    dateField2Month: newDate.getMonth(),
                    dateField2Day: newDate.getDate(),
                    dateField2Hour: newDate.getHours(),
                    dateField2Minute: newDate.getMinutes(),
                    dateField2Second: newDate.getSeconds(),
                    ajax: true
                },
                success: function(response) {
                    if (!notifSent) {
                        // Application soumise au chercheur
                        notificationUtils.sendNotificationPerson(
                            artistId,
                            "APPLICATION_SUBMITTED",
                            auditionName + "*|||*" + window.location.href.split('?')[0],
                            callback,
                            {field8: personId}
                        );
                        if (applicationNotification !== '1') {
                            notificationUtils.sendNotificationPerson(
                                searcherId,
                                "AUDITION_CHERCHEUR_APPLICATION_SUBMITTED",
                                artistName + "*|||*" + auditionName + "*|||*" + window.location.href.split('?')[0],
                                callback,
                                {field8: personId}
                            );
                        }
                    } else {
                        callback();
                    }
                    notifSent = true;
                }
            });
        }
	};
	
	var reviewDemoByAgencySubmit = function () {
		var t = $(this);
		var artistId = t.attr('data-item-id');
		var currArtistCtn = $('.audition-single-artist-item[data-id="'+artistId+'"]');
		var currArtistHeader = $('.audition-single-artist-item-header', currArtistCtn);
		var currPopup = $(this).closest('.popup');
		var total = $('.audition-single-artist-item-script-demo-recommend', currArtistCtn).length;
		var count = 0;
		
		currPopup.addClass('is-processing');
		
		
		$('.audition-single-artist-item-script-demo-recommend', currArtistCtn).each(function () {
			var t = $(this);
			var item = t.closest('.audition-single-artist-item-script-demo-item');
			var id = item.attr('data-id');
			
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: id,
					field8: '3',
					ajax: true
				},
				success: function (response) {
					count++;
					
					if (count === total) {
							var sendEmail = currArtistHeader.attr('data-email');
							var message = $('.form-input[name="audition-review-by-agency-text"]').val() !== undefined ? $('.form-input[name="audition-review-by-agency-text"]').val().trim() : '';
							var subject = $('input[name="audition-review-by-agency-subject"]').val() !== undefined ? $('input[name="audition-review-by-agency-subject"]').val().trim() : '';
							
							sendHeaderInfo(function () {
								sendEmailAndReload(sendEmail, message, subject, 'audition-agency-not-recommended', {field1: auditionName});
							}, currArtistCtn);
					} else {
						sendHeaderInfo(function () {
							
						}, currArtistCtn);
					}
				} 
			});
		});
		
		function sendHeaderInfo(callback, currArtistCtn) {
			var currHeader = $('.audition-single-artist-item-header', currArtistCtn);
			var artistId = currHeader.attr('data-artist-id');
				
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: currHeader.attr('data-application-id'),
					field3: '2',
					ajax: true
				},
				success: function (response) {
					// Demande à l'artiste de réviser sa candidature par l'agent
					notificationUtils.sendNotificationPerson(
						artistId,
						"AUDITION_ARTIST_REVIEW",
						auditionName + "*|||*" + window.location.href.split('?')[0],
						callback,
						{ field8: personId }
					);
				}
			});
		}
	};
	
	var submitDemoToResearcherSubmit = function () {
		var t = $(this);
		var total = $('.audition-single-demo-item:not(.clone)').length + 1;
		var count = 0;
		var hasAgency = agencyId !== '';
		var currPopup = t.closest('.popup');
		var applicationData = {
			id: applicationId,
			field3: '1',
			ajax: true
		};
			
		var newDate = new Date();
			
		if (!hasAgency) {
			applicationData.dateField2Year = newDate.getFullYear();
			applicationData.dateField2Month = newDate.getMonth();
			applicationData.dateField2Day = newDate.getDate();
			applicationData.dateField2Hour = newDate.getHours();
			applicationData.dateField2Minute = newDate.getMinutes();
			applicationData.dateField2Second = newDate.getSeconds();
		} else {
			applicationData.dateField3Year = newDate.getFullYear();
			applicationData.dateField3Month = newDate.getMonth();
			applicationData.dateField3Day = newDate.getDate();
			applicationData.dateField3Hour = newDate.getHours();
			applicationData.dateField3Minute = newDate.getMinutes();
			applicationData.dateField3Second = newDate.getSeconds();
		}
		
		var _complete = function() {
			count++;		
			if (count === total) {
//				var sendEmail = $('.audition-single-submit-email-agency-email').val().trim();
//				var url = $('.audition-single-submit-email-url').val().trim();
//				var subject = $('.audition-single-submit-email-subject').val().trim();
//				var artistName = $('.audition-single-submit-email-name').val().trim();
				var urlParam = hasAgency ? 'successToAgency' : 'successToReseacher';
				
				// sendEmailAndReload(sendEmail, false, subject, 'artist-send-to-agency-to-recommended', {field1: auditionName, field2: artistName, field3: url}, urlParam);
				var redirect = window.location.href.split('?')[0];
				redirect += '?' + urlParam;
				window.location.href = redirect;
			}
		};
        
        var _notifyAutonomous = function() {
            if (agenciesListForAutonomous.length !== 0) {
                notificationUtils.sendNotificationPerson(
                    agenciesListForAutonomous,
                    "AUDITION_AUTONOMOUS_ARTIST_TO_AGENT",
                    personName + "*|||*" + auditionName,
                    _complete,
                    {field8: personId}
                );
            } else {
                _complete();
            }
        };
		
		currPopup.addClass('is-processing');
		// Audition submit demo
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: applicationData,
			success: function() {
				if (hasAgency) {
					notificationUtils.sendNotificationPerson(
						agencyId,
						"AUDITION_AGENT_APPLICATION_REVIEW",
						personName + "*|||*" + auditionName + "*|||*" + window.location.href.split('?')[0],
						_complete,
						{ field8: personId }
					);
				} else if (applicationNotification !== '1') {
					notificationUtils.sendNotificationPerson(
						searcherId,
						"AUDITION_CHERCHEUR_APPLICATION_SUBMITTED",
						personName + "*|||*" + auditionName + "*|||*" + window.location.href.split('?')[0],
						_notifyAutonomous,
						{ field8: personId }
					);
				} else {
                    _notifyAutonomous();
                }
			}
		});
		
		$('.audition-single-demo-item:not(.clone)').each(function () {
			var t = $(this);
			var id = t.attr('data-id');
			
			var data = {
				id: id,
				field8: parseInt(t.attr('data-state')) > 0 && t.attr('data-state') !== '2' && t.attr('data-state') !== '3' ? t.attr('data-state') : (hasAgency ? '1' : '4'),
				ajax: true
			};

			if (!hasAgency) {
				data.dateField2Year = newDate.getFullYear();
				data.dateField2Month = newDate.getMonth();
				data.dateField2Day = newDate.getDate();
				data.dateField2Hour = newDate.getHours();
				data.dateField2Minute = newDate.getMinutes();
				data.dateField2Second = newDate.getSeconds();
			} else {
				data.dateField3Year = newDate.getFullYear();
				data.dateField3Month = newDate.getMonth();
				data.dateField3Day = newDate.getDate();
				data.dateField3Hour = newDate.getHours();
				data.dateField3Minute = newDate.getMinutes();
				data.dateField3Second = newDate.getSeconds();
			}
			
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				success: _complete
			});
		});
	};
	
	var informArtistsSubmit = function(popup, winnerNotifName, winnerEmailName, loserNotifName, loserEmailName, isFinal) {
		var loosers = [];
		var loosersNamesByAgency = {};
		var loosersAgencies = [];
		var loosersAgenciesIds = [];
		var losersMsg = $('.form-input[name="audition-single-inform-artists-loosers-text"]', popup).val() !== undefined ? $('.form-input[name="audition-single-inform-artists-loosers-text"]', popup).val().trim() : '';
		var winners = [];
		var winnersNamesByAgency = {};
		var winnersAgencies = [];
		var winnersAgenciesIds = [];
		var winnersMsg = $('.form-input[name="audition-single-inform-artists-winners-text"]', popup).val() !== undefined ? $('.form-input[name="audition-single-inform-artists-winners-text"]', popup).val().trim() : '';
		var selectedIds = [];
		var deselectedIds = [];
		var refusedApplicationIds = [];
		var refusedArtistsCount = 0;
		var previouslyRefusedApplicationIds = [];
		var approvedArtistsCount = 0;

		if (isFinal === undefined) { isFinal = false; }
			
		popup.addClass('is-processing');
		
		$('.audition-single-artist-item').each(function () {
			var t = $(this);
			var header = $('.audition-single-artist-item-header', t);
			var agencyId = header.attr('data-agency-id');
			var agencyEmail = header.attr('data-agency-email');
			var recommandedDemosCount = 0;
			var selectedDemoCount = 0;
			
			t.find('.audition-application-demo-state-select').each(function() {
				switch (this.value) {
					case "5":
						recommandedDemosCount++;
						break;
					case "7":
						selectedDemoCount++;
						break;
				}
			});
			
			if((recommandedDemosCount > 0 && !isFinal) || (selectedDemoCount > 0 && isFinal)) {
				winners.push(header.attr('data-email'));
				if (!winnersNamesByAgency[agencyEmail]) {
					winnersNamesByAgency[agencyEmail] = [];
				}
				winnersNamesByAgency[agencyEmail].push(header.attr('data-artist-name'));
				
				selectedIds.push(header.attr('data-artist-id'));
                // To reduce the spamming on the agency emails, group the info from each recommendation of artists belong to the same agency
				if ((agencyEmail.length !== 0 || agencyId.length !== 0) && winnersAgencies.indexOf(agencyEmail) === -1 && winnersAgenciesIds.indexOf(agencyId) === -1) {
					winnersAgencies.push(agencyEmail);
					winnersAgenciesIds.push(agencyId);
				}
				if (t.hasClass('already-rejected')) {
					previouslyRefusedApplicationIds.push(header.attr('data-application-id'));
				}
			} else {
				if (!t.hasClass('already-rejected')) {
					loosers.push(header.attr('data-email'));
					if (!loosersNamesByAgency[agencyEmail]) {
						loosersNamesByAgency[agencyEmail] = [];
					}
					loosersNamesByAgency[agencyEmail].push(header.attr('data-artist-name'));
					
					deselectedIds.push(header.attr('data-artist-id'));
                    // To reduce the spamming on the agency emails, group the info from non-selected artists belong to the same agency
					if ((agencyEmail.length !== 0 || agencyId.length !== 0) && loosersAgencies.indexOf(agencyEmail) === -1 && loosersAgenciesIds.indexOf(agencyId) === -1) {
						loosersAgencies.push(agencyEmail);
						loosersAgenciesIds.push(agencyId);
					}
					refusedApplicationIds.push(header.attr('data-application-id'));
				}
			}
		});
		
		var sendLoserMsg = loosers.length > 0 && losersMsg !== '' && refusedApplicationIds.length > 0;
		var sendLoserAgenciesMsg = loosersAgencies.length > 0 && losersMsg !== '' && refusedApplicationIds.length > 0;
		var sendWinnerMsg = winners.length > 0 && winnersMsg !== '';
		var sendWinnerAgenciesMsg = winnersAgencies.length > 0 && winnersMsg !== '';

		if (sendLoserMsg) emailLimit++;
		if (sendLoserAgenciesMsg) emailLimit++;
		if (sendWinnerMsg) emailLimit++;
		if (sendWinnerAgenciesMsg) emailLimit++;
		
		var sendEmailsLosers = function () {
			if (sendLoserMsg) {
				var subjectInput = $('input[name="audition-single-inform-artists-loosers-subject"]', popup);
				var agencySubjectInput = $('input[name="audition-single-inform-artists-loosers-agency-subject"]', popup);
				var subject = subjectInput.val() !== undefined ? subjectInput.val().trim() : '';
				var agencySubject = agencySubjectInput.val() !== undefined ? agencySubjectInput.val().trim() : '';
				var fieldsByAgency = {};
				for (var i in loosersAgencies) {
					var la = loosersAgencies[i];
					fieldsByAgency[la] = {"field1": auditionName, "field2": loosersNamesByAgency[la].join(", ")};
				}
				
				// add an indication that they were refused in their application, to prevent more negative messages
				refusedApplicationIds.forEach(function(id) {		
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: id,
							field8: true,
							ajax: true
						},
						success: function (response) {
							refusedArtistsCount++;

							if (refusedArtistsCount >= refusedApplicationIds.length) {
                                // Send email to Artists
								sendEmailAndReload(loosers, losersMsg, subject, loserEmailName, {field1: auditionName}, 'messageSent');
								if (sendLoserAgenciesMsg) {
                                    // Send email to Agencies
									sendEmailsSeparateFieldsAndReload(loosersAgencies, losersMsg, agencySubject, loserEmailName + '-agency', fieldsByAgency, 'messageSent');
								}
							}
						} 
					});
				});
			}
		};
			
		var sendEmailsWinners = function () {
			if (sendWinnerMsg) {
				var subjectInput = $('input[name="audition-single-inform-artists-winners-subject"]', popup);
				var agencySubjectInput = $('input[name="audition-single-inform-artists-winners-agency-subject"]', popup);
				var subject = subjectInput.val() !== undefined ? subjectInput.val().trim() : '';
				var agencySubject = agencySubjectInput.val() !== undefined ? agencySubjectInput.val().trim() : '';
				var fieldsByAgency = {};
				for (var i in winnersAgencies) {
					var wa = winnersAgencies[i];
					fieldsByAgency[wa] = {"field1": auditionName, "field2": winnersNamesByAgency[wa].join(", ")};
				}
				
				// if negative message received in the past, remove the indication in the application (approved now)
				if (previouslyRefusedApplicationIds.length > 0) {
					previouslyRefusedApplicationIds.forEach(function(id) {
						$.ajax({
							url: '/action/manageGenData',
							cache: false,
							data: {
								id: id,
								field8: false,
								ajax: true
							},
							success: function (response) {
								approvedArtistsCount++;

								if (approvedArtistsCount >= previouslyRefusedApplicationIds.length) {
                                    // Send email to Artists
									sendEmailAndReload(winners, winnersMsg, subject, winnerEmailName, {field1: auditionName}, 'messageSent');
									if (sendWinnerAgenciesMsg) {
                                        // Send email to Agencies
										sendEmailsSeparateFieldsAndReload(winnersAgencies, winnersMsg, agencySubject, winnerEmailName + '-agency', fieldsByAgency, 'messageSent');
									}
								}
							} 
						});
					});
				} else {
                    // Send email to Artists
					sendEmailAndReload(winners, winnersMsg, subject, winnerEmailName, {field1: auditionName}, 'messageSent');
					if (sendWinnerAgenciesMsg) {
                        // Send email to Agencies
						sendEmailsSeparateFieldsAndReload(winnersAgencies, winnersMsg, agencySubject, winnerEmailName + '-agency', fieldsByAgency, 'messageSent');
					}
				}
			}
		};

		if ((deselectedIds.length !== 0 && sendLoserMsg) || (selectedIds.length !== 0 && sendWinnerMsg)) {
			if (sendLoserMsg) {
				// Artiste non retenu pour l'audition
				notificationUtils.sendNotificationPerson(
					deselectedIds.join(','),
					loserNotifName,
					auditionName + "*|||*" + window.location.href.split('?')[0],
					function () {
						var valuesArray = [];
						var fieldsArray = [];
						for (var i in loosersAgencies) {
							var la = loosersAgencies[i];
							valuesArray.push(auditionName + "*|||*" + loosersNamesByAgency[la].join(", ") + "*|||*" + window.location.href.split('?')[0]);
							fieldsArray.push({ field8: personId });
						}
                        // Send SMS to Agencies
						notificationUtils.sendMultipleNotificationsPersonsDifferentData(
							loosersAgenciesIds.join(","),
							loserNotifName + '_AGENCY',
							valuesArray,
							sendEmailsLosers,
							fieldsArray,
							false
						);
					},
					{ field8: personId },
					false
				);
			}
			
			if (sendWinnerMsg) {
				// Artiste retenu pour l'audition
				notificationUtils.sendNotificationPerson(
					selectedIds.join(','),
					winnerNotifName,
					auditionName + "*|||*" + window.location.href.split('?')[0],
					function () {
						var valuesArray = [];
						var fieldsArray = [];
						for (var i in winnersAgencies) {
							var wa = winnersAgencies[i];
							valuesArray.push(auditionName + "*|||*" + winnersNamesByAgency[wa].join(", ") + "*|||*" + window.location.href.split('?')[0]);
							fieldsArray.push({ field8: personId });
						}
                        // Send SMS to Agencies
						notificationUtils.sendMultipleNotificationsPersonsDifferentData(
							winnersAgenciesIds.join(","),
							winnerNotifName + '_AGENCY',
							valuesArray,
							sendEmailsWinners,
							fieldsArray,
							false
						);
					},
					{ field8: personId },
					false
				);
			}
		} else {
			window.location.reload();
		}
	};
	
	var sendEmailAndReload = function (sendEmail, message, subject, email, fields, successParam) {
		if (message.length !== 0 || message === false) {
			utils.sendEmail(sendEmail.toString(), subject, message, email + '-' + lang, fields, function(response) {
				// console.log(email + ' : ' + response);
				emailCount++;
				
				if (emailCount >= emailLimit) {
					var redirect = window.location.href.split('?')[0];
					
					if (typeof successParam === 'string') {
						if (successParam.length !== 0) {
							redirect += '?' + successParam;
						}
					}
					
					window.location.href = redirect;
				}
			});
		} else {
			window.location.reload();
		}
	};
	
	var sendEmailsSeparateFieldsAndReload = function(sendEmails, message, subject, html, fieldsByEmail, successParam) {
		if (message.length !== 0 || message === false) {
			var currentEmailsCount = sendEmails.length;
			
			
			for (var i in sendEmails) {
				var email = sendEmails[i];
				utils.sendEmail(email, subject, message, html + '-' + lang, fieldsByEmail[email], function(response) {
					currentEmailsCount--; // current 
					emailCount++; // global
					
					if (currentEmailsCount === 0 && emailCount >= emailLimit) {
						var redirect = window.location.href.split('?')[0];
						
						if (typeof successParam === 'string') {
							if (successParam.length !== 0) {
								redirect += '?' + successParam;
							}
						}
						
						window.location.href = redirect;
					} 
				});
			}
		} else {
			window.location.reload();
		}
	};
	
	var confirmFinalChoice = function () {
		var popup = $(this).closest('.popup');
		popup.addClass('is-processing');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: auditionId,
				field13: '3',
				ajax: true
			},
			success: function (response) {
				if (response.indexOf('success') !== -1) {
					informArtistsSubmit(popup, 'AUDITION_ARTIST_SELECTED_FINAL', 'audition-selected', 'AUDITION_ARTIST_NOT_SELECTED', 'audition-not-selected', true);
				} else {
					popup.removeClass('is-processing');
				}
			} 
		});
	};
	var loadMoreList = function () {
		var t = $(this);
		var type = t.attr('data-id');
		var param = '?more=true';
        
        if (type === 'alpha') {
            param += '&sortBy=alpha';
        }
        /* Since the descending sorting is done by css, we don't send the order to the request
        if (mainContent.hasClass('inverted')) {
            param += '&sortOrder=desc';
        }*/
        /* Disabled backend filter so that the unselected artists can be notified
        if ($('.audition-filter-by-state').val() !== '') {
            param += '&field8=' + $('.audition-filter-by-state').val();
        }*/
        
		mainContent.addClass('is-processing');
		$.ajax({
			url: window.location.href.split('?')[0] + param,
			cache: false,
			success: function (response) {
				var temp = $('<div></div>');
				$('.moreApplications').val('true');
				temp.html(response);
				$('.audition-single-artist-ctn', orderListCtn).remove();
				orderListCtn.prepend($('.audition-single-artist-ctn', temp).clone());
			   	$('.audition-application-demo-state-select', orderListCtn).change(changeAuditionDemoState);
				mainContent.removeClass('is-processing');
				t.hide();
			}
		});
	};
	
	var loadOrderedList = function () {
		var t = $(this);
		var type = t.attr('data-id');
		
		if (!$('.audition-single-artist-ctn', orderListCtn).hasClass(type)) {
            orderBtns.removeClass('selected')
                .filter('[data-id="' + type + '"]').addClass('selected');
            moreApplicationsBtns.attr('data-id', type);
            
			var param = '?sortBy=dateField2';
			
			if (type === 'alpha') {
				param = '?sortBy=alpha';
			}
            /* Since the descending sorting is done by css, we don't send the order to the request
            if (mainContent.hasClass('inverted')) {
                param += '&sortOrder=desc';
            }*/
            /* Disabled backend filter so that the unselected artists can be notified
			if ($('.audition-filter-by-state').val() !== '') {
				param += '&field8=' + $('.audition-filter-by-state').val();
			}*/
			if ($('.moreApplications').val() === 'true') {
				param += '&more=true';
			}
			
			mainContent.addClass('is-processing');
			$.ajax({
				url: window.location.href.split('?')[0] + param,
				cache: false,
				success: function (response) {
					var temp = $('<div></div>');
					temp.html(response);
					$('.audition-single-artist-ctn', orderListCtn).remove();
					orderListCtn.prepend($('.audition-single-artist-ctn', temp).clone());
					$('.audition-application-demo-state-select', orderListCtn).change(changeAuditionDemoState);
					mainContent.removeClass('is-processing');
				}
			});
		}
	};
	
	var showOrderedList = function (type) {
		var selected = $('.audition-single-artist-ctn').filter(function () { return $(this).css('display') === 'block'; });
		
		if ($('.audition-single-artist-ctn.'+type).css('display') === 'none') {
			$('.audition-single-researcher-tools-order-btn').removeClass('selected');
			$('.audition-single-researcher-tools-order-btn[data-id="'+type+'"]').addClass('selected');
		
			selected.fadeOut(300, function () {
				$('.audition-single-artist-ctn.'+type).fadeIn(300);
			});
		}
	};
	
	var toggleOrderReverse = function () {
		mainContent.toggleClass('inverted');
		
		var selectedBtn = $('.audition-single-artist-ctn').filter(function () { return $(this).css('display') === 'block'; });
		selectedBtn.trigger('click');
	};
	
	var commentaireBtnSubmit = function () {
		var currForm = $(this).closest('form');
		currForm.addClass('is-processing');
		
		var newDate = new Date();
		$('.audition-commentaire-form input[name="dateField1Year"]').val(newDate.getFullYear());
		$('.audition-commentaire-form input[name="dateField1Month"]').val(newDate.getMonth());
		$('.audition-commentaire-form input[name="dateField1Day"]').val(newDate.getDate());
		$('.audition-commentaire-form input[name="dateField1Hour"]').val(newDate.getHours());
		$('.audition-commentaire-form input[name="dateField1Minute"]').val(newDate.getMinutes());
		$('.audition-commentaire-form input[name="dateField1Second"]').val(newDate.getSeconds());
		
		notificationUtils.sendNotificationPerson($('.audition-single-audition-invitees').val(),
			'AUDITION_NEW_COMMENT',
			auditionName + '*|||*' + window.location.href.split('?')[0],
			function () {
			currForm.submit();
			},
			{field8: personId}
		);
		
		return false;
	};
	
	var commentaireDelBtnSubmit = function () {
		var t = $(this);
		var item = t.closest('.audition-commentaire-item');
		var itemId = item.attr('data-id');
		
		item.slideUp(200, function () {
			item.remove();
		});
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: {
				id: itemId,
				delete: true,
				ajax: true
			},
			success: function (response) {
				// console.log('Commentaire del : ' + response);
			}
		});
	};
	
	var toggleDetails = function() {
		var $ctn = $(".dashboard-style-page");
		$ctn.toggleClass("mobile-open");
	};

	var saveConfidentiality = function() {
		var t = $(this);
		var auditionId = t.attr('data-extra').split('-')[0];
		var personId = t.attr('data-extra').split('-')[1];
		var currPopup = t.closest('.popup');

		var data = {
			field1: 'audition-confidentiality',
			field2: auditionId,
			field3: personId,
			ajax: true
		};

		currPopup.addClass('is-processing');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
				// console.log('confidentiality : ' + response);

				if (t.hasClass('js-trigger-accept-audition-btn')) {
					currPopup.find('.js-audition-single-audition').trigger('click');
				} else {
					window.location.reload();
				}
			}
		});
	};
	
	var sendSelectEmailSubmit = function () {
		var btn = $(this);
		var popup = btn.closest('.popup');
		var subject = $('input[name="audition-single-send-select-subject"]', popup).val();
		var href = $('input[name="audition-single-select-partner-default-url"]', popup).val();
		var name = $('input[name="audition-single-send-select-winners-name"]', popup).val();
		var sendEmail = $('input[name="audition-single-send-select-send-email"]', popup).val();
		var message = $('textarea[name="audition-single-send-select-message"]', popup).val();
		var popupForm = popup.find('.js-audition-single-send-select-form');
		var doSendEmail = true;
		var doSetListToken = true;
			
		if (popupForm.find('[name=toggle-share-client-artists-list-checkbox]').length > 0) {
			doSendEmail = popupForm.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked');
		}
			
		if (popup.find('[name=toggle-share-client-artists-list-checkbox]').length > 0) {
			doSetListToken = popup.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked');
		}

		var sendTo = $('[name="audition-single-send-select-to"]', popup).attr('data-value');

		var tokenJson;
		if (auditionClientJson !== '') {
			tokenJson = JSON.parse(auditionClientJson);
		} 
		else {
			tokenJson = {};
		}

		tokenJson.client = $('input[name="audition-single-select-client-token"]', popup).attr('data-token');
		tokenJson.partner = $('input[name="audition-single-select-partner-token"]', popup).attr('data-token');
		
		if (sendTo === 'client' && tokenJson.client.length === 0) {
			tokenJson.client = $('input[name="audition-single-select-client-token"]', popup).val();
		} else if (sendTo === 'partner' && tokenJson.partner.length === 0) {
			tokenJson.partner = $('input[name="audition-single-select-partner-token"]', popup).val();
		}
		
		if (sendTo === 'client' && tokenJson.client.length !== 0) {
			href += '?t=' + tokenJson.client;
		} else if (sendTo === 'partner' && tokenJson.partner.length !== 0) {
			href += '?p=' + tokenJson.partner;
		}

		if (popupForm.attr('data-extra-param') !== undefined && popupForm.attr('data-extra-param').length > 0) {
			href += '&' + popupForm.attr('data-extra-param');
		}
		
		var _onSubmit = function() {
			if (btn.hasClass('inform-artists') && (popup.find(toggleArtistRecommendedMsgCheckbox).prop('checked') || popup.find(toggleArtistNotRecommendedMsgCheckbox).prop('checked'))) {
				informArtistsSubmit(popup, 'AUDITION_ARTIST_SELECTED', 'audition-recommended', 'AUDITION_ARTIST_NOT_SELECTED', 'audition-not-recommended');
			} else {
				var forward = popupForm.attr('data-forward');
				if ((popup.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked') && popup.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked')) || popup.find('[name=toggle-share-client-artists-list-checkbox]').length === 0) {
					forward.indexOf('?') !== -1 ? forward += '&' : forward += '?';
					forward += 'messageSent';
				}

				window.location.href = forward;
			}
		};

		form.validateForm(popupForm);
		
		if (!popupForm.hasClass('has-error')) {
			popup.addClass('is-processing');

			if (doSetListToken) {
				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: {
						id: auditionId,
						field7: JSON.stringify(tokenJson),
						ajax: true
					},
					success: function (response) {
						if (doSendEmail) {
							utils.sendEmail(sendEmail.toString(), subject, message, popupForm.attr('data-email-name') + lang, {field1: auditionName, field2: href}, _onSubmit);
						} else {
							_onSubmit();
						}
					}
				});
			} else {
				_onSubmit();
			}
		}
	};
	
	var sendEmailToggleForm = function () {
		var t = $(this);
		
		if (t.attr('value') !== '') {
			sendToForm.slideDown(200);
			
			sendToForm.attr('data-cat', t.attr('value'));
		} else {
			sendToForm.slideUp(200);
		}
	};

	// new recommended / final choice change for searcher
	var changeAuditionDemoState = function() {
		var t = $(this);
		var currHeader = t.closest('.audition-single-artist-item').find('.audition-single-artist-item-header');
		var item = t.closest('.audition-single-artist-item-script-demo-item');
		var id = item.attr('data-id');
		var item = $('.audition-single-artist-item-script-demo-item[data-id='+id+']');
		var newState = '6';
		var artist = currHeader.find(".audition-single-artist-item-name").text();
		var demo = item.find('.audition-single-artist-item-script-demo-title').text();
		var artistsRecommendedList = $('.audition-single-send-select-form-artists-list.recommended');
		var artistsFinalList = $('.audition-single-send-select-form-artists-list.final');
		var demoStateTextCtn = item.find(demoState);
		
		if (t.val() !== '') {
			newState = t.val();
		}
		
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: id,
				field8: newState,
				ajax: true
			},
			success: function (response) {
				if (response.indexOf('success') !== -1) {
					var data = {
						id: auditionId,
						ajax: true
					};
                    
					if (newState === '5' && recommendedDate.length === 0) {
						var newDate = new Date();
						recommendedDate = newDate;
						dateChanged = true;
						data.dateField4Year = newDate.getFullYear();
						data.dateField4Month = newDate.getMonth();
						data.dateField4Day = newDate.getDate();
						data.dateField4Hour = newDate.getHours();
						data.dateField4Minute = newDate.getMinutes();
						data.dateField4Second = newDate.getSeconds();
						item.find('select[name=audition-application-demo-state-select]').val('5');
					} else if (newState !== '5' && recommendedDate.length !== 0 && auditionDemoStateSelect.filter(function() { return $(this).val() === '5'; }).length === 0) {
						recommendedDate = '';
						dateChanged = true;
						data.deleteDateField4 = true;
					}
                    
                    item.attr('data-state', newState);
                    item.removeClass('is-recommended is-preselected is-selected');

					if (newState !== '6') {
						if (newState === '5') {
                            item.addClass('is-recommended');
							_addToArtistList(artistsRecommendedList);
							_removeFromArtistList(artistsFinalList);
							_checkFinal();
							demoStateTextCtn.html(demoStateTextCtn.attr('data-recommended'));
							item.find('select[name=audition-application-demo-state-select]').val('5');
						} else if (newState === '7') {
                            if (item.attr('data-client') === 'true') {
                                item.addClass('is-recommended');
                                _addToArtistList(artistsRecommendedList);
                            } else if (item.attr('data-audition-state') === '3') {
                                item.addClass('is-selected');
                            } else {
                                item.addClass('is-recommended is-preselected');
                                _addToArtistList(artistsRecommendedList);
                            }
							_addToArtistList(artistsFinalList);
							artistsFinalList.closest('.audition-choice-popup-content-ctn').attr('data-cat', 'choice');
							demoStateTextCtn.html(demoStateTextCtn.attr('data-final'));
							item.find('select[name=audition-application-demo-state-select]').val('7');
						}

						if (item.attr('data-audition-state') === '1' && currAuditionState !== '2') {
							data.field13 = '2';
							$.ajax({
								url: '/action/manageGenData',
								cache: false,
								data: data,
								success: function (response) {
									if (response.indexOf('success') !== -1) {
										dateChanged = false;
										$('.audition-single-send-select-btn').removeAttr('disabled').removeAttr('title');
										// change audition state bar display
										$('.audition-single-artist-state-info-val').html($('.audition-single-main-title').attr('data-state-recommended'));
										$('.audition-single-artist-state-info').addClass('warning');
										currAuditionState = '2';
									}
								} 
							});
						}
					} else {
						demoStateTextCtn.html(demoStateTextCtn.attr('data-refused'));
						item.find('select[name=audition-application-demo-state-select]').val('');

						_removeFromArtistList(artistsRecommendedList);
						_removeFromArtistList(artistsFinalList);
						_checkFinal();
					}
                    
                    $('.audition-single-researcher-tools-recommended-count').text(artistsRecommendedList.find('p[data-id]').length);

					setTimeout(function() {
						$.ajax({
							url: '/action/manageGenData',
							cache: false,
							data: data,
							success: function (response) {
								// console.log(response)
								if (response.indexOf('success') !== -1) {
									dateChanged = false;
								}
							} 
						});
					}, 1000);
				}
			} 
		});

		var _addToArtistList = function(list) {
			if (list.find('p[data-id='+ id +']').length === 0) {
				list.append('<p data-id="'+ id +'">'+ artist + ' - ' + demo +'</p>');
			}
		};

		var _removeFromArtistList = function(list) {
			if (list.find('p[data-id='+ id +']').length > 0) {
				list.find('p[data-id='+ id +']').remove();
			}
		};

		var _checkFinal = function() {
			if (artistsFinalList.find('p').length === 0) {
				artistsFinalList.closest('.audition-choice-popup-content-ctn').attr('data-cat', 'no-choice');
			}
		};
	};
	
	var toggleRelatedInputContent = function() {
		var t = $(this);
		var id = t.attr('data-id');
		var textarea = $('.element-to-toggle[data-id=' + id +'] textarea');

		if (!t.prop('checked')) {
			textarea.attr('data-misc', textarea.val());
			textarea.val('');
		} else {
			textarea.val(textarea.attr('data-misc'));
		}
	};

	var returnToChoicesState = function() {
		var btn = $(this);
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: auditionId,
				field13: '2',
				ajax: true
			},
			success: function (response) {
				if (response.indexOf('success') !== -1) {
					window.location.href = btn.attr('data-redirect');
				}
			} 
		});
	};

	var submitClientComment = function() {
		var btn = $(this);
		var popup = btn.closest('.popup');
		var ctn = popup.find('.audition-single-client-textarea-ctn');
		var json = JSON.parse(auditionClientJson);
		var type = ctn.attr('data-clienttype');

		json[type + '-comment'] = ctn.find('textarea').val();
		json[type + '-comment-read'] = false;

		formValidator.validateForm(ctn);

		if (!ctn.hasClass('has-error')) {
			popup.addClass('is-processing');
			$.ajax({
				url: '/action/vcValidateClientChoice',
				cache: false,
				data: {
					id: auditionId,
					comment: JSON.stringify(json),
					ajax: true
				},
				success: function (response) {
					if (response.indexOf('success') !== -1) {
						var notifName = '';

						window.location.href.indexOf('p=') !== -1 ? notifName = 'AUDITION_NEW_COMMENT_PARTNER' : 'AUDITION_NEW_COMMENT_CLIENT';

						notificationUtils.sendNotificationPerson(searcherId,
							notifName,
							auditionName + '*|||*' + window.location.href.split('?')[0],
							function () {
								window.location.href = btn.attr('data-redirect');
							},
							{field8: personId}
						);
					} else {
						popup.removeClass('is-processing');
					}
				} 
			});
		}
	};
	
	var deleteApplication = function () {
		var t = $(this);
		var redirect = t.attr('data-redirect');
		var ids = t.attr('data-extra');
		$(this).closest('.popup').addClass('is-processing');

		var hasAgency = agencyId !== '';
		var currAgencyId = $('.audition-single-agency-select').length !== 0 ? $('.audition-single-agency-select').attr('data-value') : agencyId;
		
		// delete application
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: ids.split('-')[0],
				delete: true,
				ajax: true
			},
			success: function (response) {
				if (ids.indexOf('!') !== -1 && ids.split('!')[1].length > 0) {
					// artist applied on a public audition without being invited and isn't autonomous
					// delete audition link, if with agency (audition-invitation)
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: ids.split('!')[1],
							delete: true,
							ajax: true
						},
						success: function (response) {
							window.location.href = redirect + '?auditionCancel';
						}
					});
				} else if (ids.split('-')[1].length > 0 && ids.indexOf('!') === -1) {
					// was invited by someone
					// reset invitation (application-invitation) state
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: ids.split('-')[1],
							field5: '',
							ajax: true
						},
						success: function (response) {
							if (hasAgency && !isAutonomous) {
								notificationUtils.sendNotificationPerson(currAgencyId,
									'AUDITION_ARTIST_REFUSED',
									personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
									function () {
										window.location.href = redirect + '?auditionCancel';
									},
									{field8: personId}
								);
							} else {
								// notify the searcher
								notificationUtils.sendNotificationPerson(researcherId,
									'AUDITION_ARTIST_REFUSED_TO_RESEARCHER',
									personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
									function () {
										window.location.href = redirect + '?auditionCancel';
									},
									{field8: personId}
								);
							}
						}
					});
				} else {
					// artist applied on a public audition without being invited and is autonomous
					window.location.href = redirect + '?auditionCancel';
				}
			}
		});
	};

	var markCommentsAsRead = function() {
		var t = $(this);
		var tokenJson = JSON.parse(auditionClientJson);
		tokenJson["client-comment-read"] = true;
		tokenJson["partner-comment-read"] = true;

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: auditionId,
				field7: JSON.stringify(tokenJson),
				ajax: true
			},
			success: function (response) {
				if (response.indexOf('success') !== -1) {
					t.find('.notification-count-ctn').fadeOut();
				}
			}
		});
	};
	
	var removeParamsOnLoad = function(paramsToRemove) {
		var params = location.search.substr(1).split('&');
		var found = false;
		
		for (var i in paramsToRemove) {
			var p = paramsToRemove[i];
			if (params.indexOf(p) !== -1) {
				found = true;
				params.splice(params.indexOf(p), 1);
			}
		}
		
		if (found) {
			var paramsString = params.length > 0 ? "?" : "";
			paramsString += params.join('&');
			
			history.pushState(null, "", location.origin + location.pathname + paramsString);
			
			setTimeout(function() {
				$('.form-popup-message.form-audition-created-msg.show').removeClass("show");
				$('.form-popup-message.form-audition-edited-msg.show').removeClass("show");
			}, 6000);
		}
	};

	var updateShareType = function () {
		var select = $(this);
		var form = $(select).closest('.popup-inner');
		var upload = $('.form-item-upload', form);
		var gendataId = $('input[name="gendataId"]', form).val();
		var mediaId = $('input[name="userMediaId"]', form).val();
		var field26Data = $('input[name="field26Data"]', form).val();
		
		var tokenJson;
		if (field26Data.length != 0 && field26Data !== '') {
			tokenJson = JSON.parse(field26Data);
		} 
		else {
			tokenJson = {};
		}

		if(select.val() == 'customImage') {
			upload.removeClass('hide');

			tokenJson.whiteLabel = "true";
			tokenJson.type = "custom";

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field26: JSON.stringify(tokenJson),
					ajax: true
				},
				success: function (response) {
					console.log('save-share : ' + response);
					$('input[name="field26Data"]', form).val(JSON.stringify(tokenJson));
				}
			});
		}
		else if(select.val() == 'profileImage') {
			upload.addClass('hide');

			tokenJson.whiteLabel = "true";
			tokenJson.type = "profile";
			tokenJson.file = '/static/uploaded/Profile/' + mediaId + '-main.jpg'

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field26: JSON.stringify(tokenJson),
					ajax: true
				},
				success: function (response) {
					console.log('save-share : ' + response);
					$('input[name="field26Data"]', form).val(JSON.stringify(tokenJson));
				}
			});
		}
		else {
			upload.addClass('hide');

			tokenJson.whiteLabel = "false";
			tokenJson.type = "default";

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field26: JSON.stringify(tokenJson),
					ajax: true
				},
				success: function (response) {
					console.log('save-share : ' + response);
					$('input[name="field26Data"]', form).val(JSON.stringify(tokenJson));
				}
			});
		}
	};

	var changeSharePic = function () {
		var t = $(this);
		var form = $(t).closest('.popup-inner');
		var gendataId = $('input[name="gendataId"]', form).val();
		var files = t[0].files;
		var size = files[0].size;
		var field26Data = $('input[name="field26Data"]', form).val();
		
		var tokenJson;
		if (field26Data.length != 0 && field26Data !== '') {
			tokenJson = JSON.parse(field26Data);
		} 
		else {
			tokenJson = {};
		}

		console.log('size : ' + size);

		if (files !== undefined) {
			if (size <= 1048576) { // 1MB
				// $('.account-pic-img-ctn').addClass('is-processing');

				for (var i = 0; i < files.length; i++) {

					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1].toLowerCase();

					if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
						var data = new FormData();
						data.append('image', files[i]);
						data.append('customLabel', 'share');
						data.append('directory', 'Share');
						data.append('ajax', 'true');

						$.ajax({
							url: '/action/uploadCroppedImage',
							cache: false,
							contentType: false,
							processData: false,
							method: 'POST',
							data: data,
							success: function (response) {
								console.log(response);
								var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
								console.log('file: ' + newFileId);
								
								var newDate = new Date();

								tokenJson.file = '/static/uploaded/Share/' + newFileId + '-share.jpg';
								
								$.ajax({
									url: '/action/manageGenData',
									cache: false,
									data: {
										id: gendataId,
										field26: JSON.stringify(tokenJson),
										ajax: true
									},
									success: function (genResponse) {
										// var newScriptId = genResponse.substring('success-'.length);
										console.log('Gendata: ' + genResponse);
										
										// fileCtn.removeClass('is-processing');
										// form.resetUpload(file);
										
										// callback(newFileId, ext, filename, newScriptId);
									} 
								});
							}
						});
					} else {
						$('.account-pic').removeClass('is-processing');
						var errorMessage = $('.form-popup-message.profile-pic-error');

						errorMessage.addClass('show');

						setTimeout(function () {
							errorMessage.removeClass('show');
						}, 5000);
					}
				}
			} else {
				form.showErrorPopupAnimation('profile-pic-size-message-error');
			}
		}
	};
    
    var filterApplications = function(e) {
        var it = e.currentTarget;
        var elems = $('.audition-single-artist-item');
        
        if (it.value !== '') {
            elems.has('.audition-single-artist-item-script-demo-item:not([data-state="' + it.value + '"])').addClass('hide');
            elems.has('.audition-single-artist-item-script-demo-item[data-state="' + it.value + '"]').removeClass('hide');
        } else {
            elems.removeClass('hide');
        }
    };
	
	var init = function () {
		notificationUtils = Fw.component.models().notificationUtils;
		formValidator = Fw.component.models().form;
		utils = Fw.component.models().utils;
		form = Fw.component.models().form;
		popup = Fw.component.models().popup;
		
		lang = $('html').attr('lang');
		titles = $('.audition-specs-title');
		auditionState = $('.audition-single-audition-state').val();
		auditionId = $('.audition-single-audition-id').val();
		auditionName = $('.audition-single-main-title').text();
		auditionClientJson = $('.audition-single-client-json').val();
		auditionFileType = $('.auditionFileType').val() !== '' ? $('.auditionFileType').val() : '0';
		isVideo = auditionFileType === '1';
		searcherId = $('.audition-single-audition-researcher-id').val();
		personName = $('.logged-user-profile-name', $(".site-header")).text();
		personFName = $('.audition-single-person-fname').val();
		personLName = $('.audition-single-person-lname').val();
		personId = $('.audition-single-person-id').val();
		applicationId = $('.audition-single-application-id').val();
		agencyId = $('.audition-single-artist-agency').val() !== undefined ? $('.audition-single-artist-agency').val() : '';
		inviteId = $('.audition-single-invite').val() !== undefined ? $('.audition-single-invite').val() : '';
		researcherId = $('.researcherId').val() !== undefined ? $('.researcherId').val() : '';
		agencyName = $('.agencyName').val() !== undefined ? $('.agencyName').val() : '';
		isAutonomous = $('.isAutonomous').val() === 'true';
		agenciesListForAutonomous = $('.isArtistListForAutonomous').val();
		recommendedDate = $('.audition-single-recommended-date').val();
		acceptAuditionBtn = $('.js-audition-single-audition');
		denyInvitationAgencyBtn = $('.js-audition-single-deny-invitation-agency');
		addDemoInput = $('.form-item-field[name="audition-single-add-file"]');
		addDemoBtn = $('.js-audition-single-add-btn');
		submitDemoByAgency = $('.js-audition-single-select-by-agency');
		reviewDemoByAgency = $('.js-audition-single-review-by-agency');
		submitDemoToResearcher = $('.js-audition-single-submit-researcher');
		submitApplicationBtn = $('.audition-single-submit-application-btn');
		demoLimit = parseInt($('.audition-single-add-from').eq(0).attr('data-limit'));
		scriptDemoRecommendedCheck = $('.audition-single-artist-item-script-demo-recommend');
		orderBtns = $('.audition-single-researcher-tools-order-btn');
		moreApplicationsBtns = $('.application-more-btn');
		orderReverse = $('.audition-single-researcher-tools-order-reverse');
		mainContent = $('.audition-single-researcher-content');
		orderListCtn = $('.audition-single-artist-big-ctn');
		commentaireBtn = $('.audition-commentaire-form-btn');
		commentaireDelBtn = $('.audition-specs-item-del-btn');
		isOwnerResearcher = $('.isOwnerResearcher').val() === 'true';
		sendSelectEmail = $('.js-audition-single-send-select');
		sendToSelect = $('.audition-single-send-select-to');
		sendToForm = $('.audition-single-send-select-form');
		auditionDemoStateSelect = $('.audition-application-demo-state-select');
		toggleArtistRecommendedMsgCheckbox = $('[name=toggle-artist-recommended-msg-checkbox]');
		toggleArtistNotRecommendedMsgCheckbox = $('[name=toggle-artist-not-recommended-msg-checkbox]');
		demoState = $('.audition-single-artist-item-script-demo-item-state');
		applicationNotification = $('.applicationNotification').val();

		titles.click(toggleContent);
		acceptAuditionBtn.click(acceptAudition);
		denyInvitationAgencyBtn.click(denyInvitationAgency);
		addDemoInput.change(checkDemoCount);
		// addDemoBtn.click(addDemoSubmit);
		addDemoInput.change(addDemoSubmitFromInput);
		submitDemoByAgency.click(submitDemoByAgencySubmit);
		reviewDemoByAgency.click(reviewDemoByAgencySubmit);
		submitDemoToResearcher.click(submitDemoToResearcherSubmit);
		$('body').on('click', '.audition-single-demo-item-del', delDemo);
		scriptDemoRecommendedCheck.change(changeScriptDemoState);
		orderBtns.click(loadOrderedList);
		moreApplicationsBtns.click(loadMoreList);
		orderReverse.click(toggleOrderReverse);
		commentaireBtn.click(commentaireBtnSubmit);
		commentaireDelBtn.click(commentaireDelBtnSubmit);
		$('.save-confidentiality-agreement-btn').click(saveConfidentiality);
		sendSelectEmail.click(sendSelectEmailSubmit);
		sendToSelect.on('click', '.select-option', sendEmailToggleForm);
		auditionDemoStateSelect.change(changeAuditionDemoState);
		$('.js-audition-single-final-choice').click(confirmFinalChoice);
		toggleArtistRecommendedMsgCheckbox.click(toggleRelatedInputContent);
		toggleArtistNotRecommendedMsgCheckbox.click(toggleRelatedInputContent);
		$(".audition-single-details-btn").on("click", toggleDetails);
		$('.js-audition-single-modify-choices').click(returnToChoicesState);
		$('.js-audition-client-comment').click(submitClientComment);
		$('.js-audition-single-delete-application').click(deleteApplication);
		$('.audition-specs-title.notif-comments-read').click(markCommentsAsRead);
		$('[name="audition-single-form-type"]').change(updateShareType);
		$('[name="audition-single-custom-pic"]').change(changeSharePic);
        $('.audition-filter-by-state').change(filterApplications);
		
		removeParamsOnLoad(["auditionCreated", "auditionEdited"]);
        
        orderListCtn.removeClass('is-processing initiating');
	};
	
	$(window).ready(init);
    
//    window.sendEmailTest999 = function() {
//        emailCount = 0;
//        emailLimit = 1;
//        sendEmailAndReload(
//            "nelo.dev@outlook.com", 
//            "Ce message est pour vous aviser que vous n'avez pas �t� retenu pour ce projet. Merci d'avoir particip� � cette audition.", 
//            "Vous n'\xEAtes pas retenu pour le projet", 
//            "audition-not-selected", 
//            {field1: "Gin Jardin Verde GLAM"}, 
//            'messageSent');
//    };
	
})(jQuery);